import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import SharedHelmet from "../Helmet";
import {
  SecondAds,
  FirstAds,
  MobileUnderCalAds
} from "../../Ads";
import { SERVER_URL } from "./ConstantsHealthCalculator";
import { BMR_EndPoint } from "./ConstantsHealthCalculator";
import BMRTable from "./BMRTable";
const TITLE = "حساب معدل الايض الاساسي - حاسبة BMR";
const DESCRIPTION =
  "تعتمد آلة حاسبة BMR المجانية والمتقدمة لدينا على صيغة BMR المعروفة وتساعد على حساب معدل الأيض الأساسي (BMR) ، عدد السعرات الحرارية في اليوم";
const KEYWORDS =
  "حساب معدل الأيض الأساسي, حاسبة BMR, معدل الأيض الأساسي للجسم, كيفية حساب معدل الأيض الأساسي, معدل الأيض الأساسي والسعرات الحرارية, صيغة حساب معدل الأيض الأساسي, ما هو معدل الأيض الأساسي؟, أهمية معدل الأيض الأساسي للصحة, كيف يؤثر معدل الأيض الأساسي على فقدان الوزن؟, طرق زيادة معدل الأيض الأساسي";
const OG_URL = "https://do-calculate.com/calculator/ar/bmr/";
const apiEndpoint = `${SERVER_URL}/${BMR_EndPoint}`;
function BMRCalculator() {
  const [weight, setWeight] = useState("");
  const [height, setHeight] = useState("");
  const [age, setAge] = useState("");
  const [gender, setGender] = useState("");
  const [result, setRestul] = useState(null);
  const [error, setError] = useState(null);
  const [statusCode, setStatusCode] = useState(null);
  const [classification, setClassification] = useState(null);
  const [formula, setFormula] = useState("harrisBenedictRevised");
  const [bodyFatPercentage, setBodyFatPercentage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const handleWeightChange = (event) => {
    setWeight(event.target.value);
  };
  const handleHeightChange = (event) => {
    setHeight(event.target.value);
  };
  const handleAgeChange = (event) => {
    setAge(event.target.value);
  };
  const handleGenderChange = (event) => {
    setGender(event.target.value);
  };
  const handleFormulaChange = (event) => {
    setFormula(event.target.value);
  };
  const handleBodyFatPercentageChange = (event) => {
    setBodyFatPercentage(event.target.value);
  };
  const calculateBMR = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(apiEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          weight,
          height,
          age,
          gender,
          formula,
          bodyFatPercentage,
        }),
      });
      const data = await response.json();
      setStatusCode(response.status);
      if (response.ok) {
        setRestul(data.result);
        setError(null);
        setClassification(data.result.classification);
      } else {
        setRestul(null);
        setError(data.error);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                تقوم هذه الحاسبة (BMR Calculator) بحساب معدل الايض الأساسي (BMR)
                والذي هو عبارة عن الطاقة التي يحتاجها الجسم في حالة الراحة
                التامة للحفاظ على وظائف الجسم الأساسية مثل التنفس والدورة
                الدموية ووظائف الأعضاء الأساسية الأخرى. تتأثر حاسبة معدل الأيض
                الأساسي بعوامل مثل الوزن، والطول، والعمر، والجنس، ونسبة الدهون
                في الجسم. يتم حساب معدل الأيض الأساسي باستخدام معادلات مختلفة
                مثل معادلة هاريس-بنيديكت ومعادلة ميفلين-ست جيور. يعتبر معدل
                الأيض الأساسي مهمًا في تقدير احتياجات الطاقة اليومية للأفراد وفي
                تخطيط البرامج الغذائية والتمارين الرياضية.
                <br />
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-12 col-md-5 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  معدل الأيض الأساسي - حساب BMR
                </div>
                <hr />
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="height" className="form-label ms-2">
                      الطول
                    </label>
                  </b>
                  <input
                    type="number"
                    id="height"
                    value={height}
                    onChange={handleHeightChange}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                    placeholder="175"
                  />
                  <div className="input-group-append">
                    <span className="input-group-text">سم</span>
                  </div>
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="weightNumber" className="form-label ms-2">
                      الوزن
                    </label>
                  </b>
                  <input
                    type="number"
                    id="weightNumber"
                    value={weight}
                    onChange={handleWeightChange}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                    placeholder="65"
                  />
                  <div className="input-group-append">
                    <span className="input-group-text">كغ</span>
                  </div>
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="age" className="form-label ms-2">
                      العمر
                    </label>
                  </b>
                  <input
                    type="number"
                    id="age"
                    value={age}
                    onChange={handleAgeChange}
                    className="form-control"
                    style={{ width: "90%" }}
                    placeholder="6"
                    min="2"
                    max="20"
                  />
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label >الجنس</label>
                  </b>
                  <div className="form-check form-check-inline">
                    <input
                      type="radio"
                      name="gender"
                      id="male"
                      value="male"
                      checked={gender === "male"}
                      onChange={handleGenderChange}
                      className="form-check-input"
                    />
                    <label htmlFor="male" className="form-check-label">
                      ذكر
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      type="radio"
                      name="gender"
                      id="female"
                      value="female"
                      checked={gender === "female"}
                      onChange={handleGenderChange}
                      className="form-check-input"
                    />
                    <label htmlFor="female" className="form-check-label">
                      أنثى
                    </label>
                  </div>
                </div>
                <br />
                <div>
                  <b>
                    <label htmlFor="select" className="form-label ms-2">
                      اختر الصيغة
                    </label>
                  </b>
                  <select
                    id="select"
                    className="form-select"
                    value={formula}
                    onChange={handleFormulaChange}
                  >
                    <option value="harrisBenedictRevised">
                      Harris Benedict Equation (Revised)
                    </option>
                    <option value="harrisBenedictOriginal">
                      Harris-Benedict Equation (Original)
                    </option>
                    <option value="mifflinStJeor">Mifflin-St Jeor</option>
                    <option value="schofield">Schofield</option>
                    <option value="oxford">Oxford</option>
                    <option value="katchMcArdle">Katch-McArdle</option>
                    <option value="cunningham">Cunningham</option>
                  </select>
                </div>
                <br />
                {(formula === "katchMcArdle" || formula === "cunningham") && (
                  <div className="form-group d-flex align-items-center">
                    <b>
                      <label className="form-label ms-2">نسبة الدهون</label>
                    </b>
                    <input
                      type="number"
                      id="bodyFatPercentage"
                      value={bodyFatPercentage}
                      onChange={handleBodyFatPercentageChange}
                      className="form-control"
                      style={{ width: "90%" }}
                      placeholder="6"
                      min="2"
                      max="20"
                    />
                    <div className="input-group-append">
                      <span className="input-group-text">%</span>
                    </div>
                    <br />
                  </div>
                )}
                <hr />
                <button
                  className="btn btn-success"
                  style={{ fontSize: "20px" }}
                  onClick={calculateBMR}
                       >
                    احسب
                    </button>              </div>
              <div className="col-sm-12 col-md-7">
                {result && (
                  <div>
                    <div className="alert alert-success">
                      <h5>النتائج : </h5>
                      معدل الأيض الأساسي الخاص بك: {result.bmr} سعرة حرارية.
                    </div>
                    <hr />
                    <BMRTable
                      formula={formula}
                      bmr={result.bmr}
                      Sedentary={result.DailyCalorieNeeded.Sedentary}
                      Exercise1_3={result.DailyCalorieNeeded.Exercise1_3}
                      Exercise4_5={result.DailyCalorieNeeded.Exercise4_5}
                      DailyExercise={result.DailyCalorieNeeded.DailyExercise}
                      IntenseExercise={
                        result.DailyCalorieNeeded.IntenseExercise
                      }
                      VeryIntenseExercise={
                        result.DailyCalorieNeeded.VeryIntenseExercise
                      }
                    ></BMRTable>{" "}
                    <br />
                    <div className="alert alert-warning">
                      <ul style={{ fontSize: "13px" }}>
                        <li>
                          التمرين: 15-30 دقيقة من ارتفاع معدل ضربات القلب.
                        </li>
                        <li>
                          تمرين مكثف: 45-120 دقيقة من نشاط معدل ضربات القلب
                          المرتفع.
                        </li>
                        <li>
                          تمرين مكثف للغاية: أكثر من ساعتين من نشاط معدل ضربات
                          القلب المرتفع.
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="row">
              <div className="col-auto">
                <br />
                {statusCode === 400 && (
                  <div className="alert alert-warning">
                    <b>
                      <u> حدث خطأ :</u>
                    </b>{" "}
                    يُرجى إدخال جميع الحقول بالشكل الصحيح.{" "}
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                {" "}
                معدل الأيض الأساسي (BMR) وكيفية حسابه
              </div>
              <div className="info-section-body">
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    معدل الأيض الأساسي (BMR) وكيفية حسابه{" "}
                  </h2>{" "}
                </u>{" "}
                <br />
                <p>
                  معدل الأيض الأساسي (BMR) هو عامل مهم يلعب دورًا حاسمًا في فهم
                  احتياجات جسمك الحرارية الأساسية. يعتبر حساب BMR خطوة أساسية
                  لفقدان الوزن أو الحفاظ على وزن صحي. في هذه المقالة، سنلقي نظرة
                  على مفهوم BMR وكيفية حسابه، بالإضافة إلى أهمية معرفة مستوى BMR
                  الخاص بك.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    ما هو معدل الأيض الأساسي (BMR)؟{" "}
                  </h2>{" "}
                </u>{" "}
                <br />
                <p>
                  معدل الأيض الأساسي (BMR) يمثل السعرات الحرارية التي يحتاجها
                  جسمك للقيام بوظائفه الحيوية أثناء الراحة التامة. يتعلق ذلك
                  بالطاقة اللازمة لدعم عمليات الجسم الأساسية مثل التنفس وعملية
                  ضخ الدم وصيانة الخلايا. يمكن أن يختلف معدل BMR من شخص لآخر
                  بناءً على عوامل مثل العمر والجنس والوزن والطول.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    أهمية معدل الأيض الأساسي للصحة{" "}
                  </h2>{" "}
                </u>{" "}
                <br />
                <p>
                  معرفة معدل BMR الخاص بك هو خطوة أولية في تحديد احتياجاتك
                  الحرارية اليومية. يمكن استخدام BMR كنقطة انطلاق لحساب السعرات
                  الحرارية التي تحتاجها يوميًا. يساعد هذا الحساب في تحديد كمية
                  السعرات الحرارية التي يجب تناولها للحفاظ على وزنك الحالي أو
                  لتحقيق أهداف فقدان الوزن بشكل آمن.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    كيف يؤثر معدل الأيض الأساسي على فقدان الوزن؟{" "}
                  </h2>{" "}
                </u>{" "}
                <br />
                <p>
                  لتحقيق فقدان الوزن، يجب أن تخلق عجزًا حراريًا، وهو الفارق بين
                  السعرات الحرارية التي تستهلكها وتلك التي تحتاجها جسمك. عندما
                  تعرف BMR الخاص بك، يمكنك حساب السعرات الحرارية التي تحتا
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    كيفية حساب معدل الأيض الأساسي (BMR){" "}
                  </h2>{" "}
                </u>
                نستخدم في هذه الحاسبة 7 معادلات مختلفة لحاسب معدل الأيض الأساسي
                كما هو موضح في الأسفل:
                <br/>                <div>
                  <b> Harris-Benedict Equation (Original): </b>
                  <br />
                  صيغة هاريس بينيديكت الأصلية هي واحدة من أكثر الصيغ استخدامًا
                  على الإنترنت لحساب احتياجاتك اليومية للطاقة. ومع ذلك، فإنها
                  أيضًا واحدة من الصيغ الأقل دقة.
                  <u>تحسب كالتالي:</u> <br />
                  <br />{" "}
                  <div className="alert alert-info">
                    <ul>
                      <li>
                        ذكور: 66.4730 + (13.7516 x الوزن [كغ]) + (5.0033 x الطول
                        [سم]) - (6.7550 x العمر)
                      </li>
                      <li>
                        إناث: 655.0955 + (9.5634 x الوزن [كغ]) + (1.8496 x الطول
                        [سم]) - (4.6756 x العمر)
                      </li>
                    </ul>
                  </div>
                </div>
                <br />
                <div>
                  <b> Harris Benedict Equation (Revised): </b>
                  <br />
                  في عام 1984، تم تعديل صيغة هاريس بينيديكت من قبل روزا وشيزجال.
                  تم استخدام مجموعة أبحاث أكبر في هذا التعديل.
                  <u>تحسب كالتالي:</u> <br />
                  <br />{" "}
                  <div className="alert alert-info">
                    <ul>
                      <li>
                        ذكور: 88.362 + (13.397 x الوزن [كغ]) + (4.799 x الطول
                        [سم]) - (5.677 x العمر)
                      </li>
                      <li>
                        إناث: 447.593 + (9.247 x الوزن [كغ]) + (3.098 x الطول
                        [سم]) - (4.33 x العمر)
                      </li>
                    </ul>
                  </div>
                </div>
                <br />
                <div>
                  <b> Mifflin-St Jeor:</b>
                  <br />
                  في عام 1990 تم تقديم معادلة ميفلين-ست جيور. وفي عام 2005، قامت
                  الجمعية الأمريكية للتغذية (ADA) بمقارنة معادلات معدل الأيض
                  الأساسي لهاريس بينيديكت، ميفلين-ست جيور، أوين ومنظمة الصحة
                  العالمية/منظمة الأغذية والزراعة/الأمم المتحدة (WHO/FAO/UNU)
                  ووجدت أن معادلة ميفلين-ست جيور هي الأكثر دقة، حيث تتنبأ بمعدل
                  معدل الأيض الأساسي بدقة تصل إلى 10% من القيم المقاسة.
                  <u>تحسب كالتالي:</u> <br />
                  <br />{" "}
                  <div className="alert alert-info">
                    <ul>
                      <li>
                        ذكور: (9.99 x الوزن [كغ]) + (6.25 x الطول [سم]) - (4.92
                        x العمر) + 5
                      </li>
                      <li>
                        إناث: (9.99 x الوزن [كغ]) + (6.25 x الطول [سم]) - (4.92
                        x العمر) - 161
                      </li>
                    </ul>
                  </div>
                </div>
                <br />
                <div>
                  <b> Schofield </b>
                  <br />
                  تم نشر معادلة شوفيلد في عام 1985 واستخدمتها منظمة الأغذية
                  والزراعة/منظمة الصحة العالمية/الأمم المتحدة (FAO/WHO/UNU)
                  وغيرها. ومع ذلك، كان هناك عدد غير متناسب من المشاركين في
                  مجموعة البيانات هم رجال إيطاليون يتمتعون في المتوسط بقيم معدل
                  الأيض الأساسي الأعلى. وهذا يؤثر بشكل غير عادل على النتائج
                  للمجتمعات الأخرى.
                  <u>تحسب كالتالي:</u> <br/>                  <b>ذكور:</b> <br />
                  <table >
                    <thead>
                      <tr>
                        <th className="formula-header">العمر</th>
                        <th className="formula-header">المعادلة</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>0-3</td>
                        <td>61.0 x الوزن [كغ] - 33.7</td>
                      </tr>
                      <tr>
                        <td>3-10</td>
                        <td>23.3 x الوزن [كغ] + 514</td>
                      </tr>
                      <tr>
                        <td>10-18</td>
                        <td>18.4 x الوزن [كغ] + 581</td>
                      </tr>
                      <tr>
                        <td>18-30</td>
                        <td>16.0 x الوزن [كغ] + 545</td>
                      </tr>
                      <tr>
                        <td>30-60</td>
                        <td>14.2 x الوزن [كغ] + 593</td>
                      </tr>
                      <tr>
                        <td>60+</td>
                        <td>13.5 x الوزن [كغ] + 514</td>
                      </tr>
                    </tbody>
                  </table>
                  <br />
                  <b>إناث:</b> <br />
                  <table >
                    <thead>
                      <tr>
                        <th className="formula-header">العمر</th>
                        <th className="formula-header">المعادلة</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>0-3</td>
                        <td>58.317 x الوزن [كغ] - 31.1</td>
                      </tr>
                      <tr>
                        <td>3-10</td>
                        <td>20.315 x الوزن [كغ] + 485.9</td>
                      </tr>
                      <tr>
                        <td>10-18</td>
                        <td>13.384 x الوزن [كغ] + 692.6</td>
                      </tr>
                      <tr>
                        <td>18-30</td>
                        <td>14.818 x الوزن [كغ] + 486.6</td>
                      </tr>
                      <tr>
                        <td>30-60</td>
                        <td>8.126 x الوزن [كغ] + 845.6</td>
                      </tr>
                      <tr>
                        <td>60+</td>
                        <td>9.082 x الوزن [كغ] + 658.5</td>
                      </tr>
                    </tbody>
                  </table>
                  <br />
                </div>
                <br />
                <div>
                  <b> Oxford : </b>
                  <br />
                  كما تبين من المعادلة التي ذكرت سابقًا، فقد تم إثبات عدم
                  موثوقية معادلة سكوفيلد للعديد من الأشخاص. وبناءً على ذلك، تم
                  تطوير سلسلة جديدة من المعادلات في عام 2005، تمتاز بأنها تعتمد
                  على قاعدة بيانات تحتوي على 10,552 قيمة لمعدل معدل الأيض
                  الأساسي، وتشمل مجموعة أكثر تنوعًا من المشاركين في الدراسة.
                  <u>تحسب كالتالي:</u> <br/>                  <b>ذكور:</b> <br />
                  <table >
                    <thead>
                      <tr>
                        <th className="formula-header">العمر</th>
                        <th className="formula-header">المعادلة</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>0-3</td>
                        <td>61.0 x الوزن [كغ] - 33.7</td>
                      </tr>
                      <tr>
                        <td>3-10</td>
                        <td>23.3 x الوزن [كغ] + 514</td>
                      </tr>
                      <tr>
                        <td>10-18</td>
                        <td>18.4 x الوزن [كغ] + 581</td>
                      </tr>
                      <tr>
                        <td>18-30</td>
                        <td>16.0 x الوزن [كغ] + 545</td>
                      </tr>
                      <tr>
                        <td>30-60</td>
                        <td>14.2 x الوزن [كغ] + 593</td>
                      </tr>
                      <tr>
                        <td>60+</td>
                        <td>13.5 x الوزن [كغ] + 514</td>
                      </tr>
                    </tbody>
                  </table>
                  <br />
                  <b>إناث:</b> <br />
                  <table >
                    <thead>
                      <tr>
                        <th className="formula-header">العمر</th>
                        <th className="formula-header">المعادلة</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>0-3</td>
                        <td>58.9 x الوزن [كغ] - 23.1</td>
                      </tr>
                      <tr>
                        <td>3-10</td>
                        <td>20.1 x الوزن [كغ] + 507</td>
                      </tr>
                      <tr>
                        <td>10-18</td>
                        <td>11.1 x الوزن [كغ] + 761</td>
                      </tr>
                      <tr>
                        <td>18-30</td>
                        <td>13.1 x الوزن [كغ] + 558</td>
                      </tr>
                      <tr>
                        <td>30-60</td>
                        <td>9.74 x الوزن [كغ] + 694</td>
                      </tr>
                      <tr>
                        <td>60+</td>
                        <td>10.1 x الوزن [كغ] + 569</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <br />
                <div>
                  <b> Katch-McArdle:</b>
                  <br />
                  كل من معادلتي Katch-McArdle و Cunningham تستخدم كتلة الجسم
                  النحيلة لتقدير معدل الأيض الأساسي في حالة الراحة. إذا كنت تعرف
                  نسبة الدهون في جسمك، يمكن حساب كتلة الجسم النحيلة باستخدام
                  الصيغة التالية: (1 - نسبة الدهون في الجسم / 100) × الوزن. يرجى
                  ملاحظة أنه في حاسبة معدل الأيض الأساسي/معدل الأيض في حالة
                  الراحة أعلاه، يتم حساب كتلة الجسم النحيلة تلقائيًا باستخدام
                  صيغة بور إذا لم يتم توفير نسبة الدهون في الجسم.
                  <u>تحسب كالتالي:</u> <br />
                  <br />{" "}
                  <div className="alert alert-info">
                    <ul>
                      <li>370 + (21.6 x كتلة الجسم العضلية [كغ])</li>
                    </ul>
                  </div>
                </div>
                <br />
                <div>
                  <b> Cunningham</b>
                  <br />
                  معادلة كانينغهام أكثر دقة للأشخاص الرياضيين جدًا.
                  <u>تحسب كالتالي:</u> <br />
                  <br />{" "}
                  <div className="alert alert-info">
                    <ul>
                      <li>500 + (22 x كتلة الجسم العضلية [كغ])</li>
                    </ul>
                  </div>
                </div>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    بعض الفوائد الرئيسية لحساب BMR هي{" "}
                  </h2>{" "}
                </u>
                <ol>
                  <li>
                    معرفة احتياجاتك الغذائية الأساسية: يساعدك حساب BMR في تقدير
                    السعرات الحرارية الأساسية التي يحتاجها جسمك للحفاظ على
                    وظائفه الأساسية. هذا يعني أنك ستتمكن من تحديد كمية الطاقة
                    التي تحتاجها يوميًا بناءً على هذه الأرقام الأساسية.
                  </li>
                  <li>
                    التخطيط للنظام الغذائي وفقًا للأهداف: إذا كنت تهدف إلى زيادة
                    أو خفض وزنك، يمكنك استخدام BMR كأساس لحساب عدد السعرات
                    الحرارية اللازمة لتحقيق هذه الأهداف. بزيادة السعرات الحرارية
                    يمكنك زيادة وزنك، وبخفضها يمكنك خسارة الوزن.
                  </li>
                  <li>
                    تخطيط التمارين والنشاط البدني: يمكن استخدام BMR لتحديد كمية
                    السعرات الحرارية التي يمكن أن تحترقها خلال التمارين والنشاط
                    البدني. يمكن أن يساعدك ذلك في تخطيط الجدول الزمني للتمارين
                    واختيار الأنشطة المناسبة لتحقيق أهدافك الصحية واللياقة
                    البدنية.
                  </li>
                </ol>
              </div>
            </div>
          </div>
          <br />
          <u>
            {" "}
            <h2>اسئلة متكررة</h2>
          </u>
          <br />
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  ما هو معدل الأيض الأساسي (BMR) الجيد لعمري؟
                </h3>
              </div>
              <div className="info-section-body">
                معدل الأيض الأساسي (BMR) الجيد لعمرك يعتمد على أكثر من مجرد
                العمر بحد ذاته - الجنس والطول والوزن يلعبون أيضًا دورًا. والمزيد
                من الأبحاث تشير إلى أنه كل عشر سنوات، ينخفض BMR لدى البالغين
                بنسبة 1% إلى 2% بسبب فقدان العضلات الهيكلية. من الآمن القول أنه
                إذا قمت بالحفاظ على وزن صحي من خلال اتباع التوصيات الصحية في نمط
                الحياة، يمكنك الحفاظ على BMR صحي لعمرك.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>ما هو أدق حاسب BMR؟</h3>
              </div>
              <div className="info-section-body">
                هناك العديد من الصيغ المستخدمة شائعًا لحساب BMR، بما في ذلك
                (ولكن لا تقتصر على) معادلة هاريس-بنيديكت المعدلة، ومعادلة
                كاتش-مكاردل ومعادلة ميفلين-سانت جيور. في الوقت الحالي، يعتبر
                الخبراء أن معادلة ميفلين-سانت جيور هي الأدق، ولهذا السبب
                نستخدمها في أداة الحساب لدينا أعلاه.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  هل يجب أن آكل BMR الخاص بي لفقدان الوزن؟
                </h3>
              </div>
              <div className="info-section-body">
                نظرًا لأن BMR يمثل كمية الطاقة التي يحتاجها جسمك للحفاظ على
                وظائفه الحيوية يوميًا، فإنه ليس من المستحسن تناول كمية أقل من
                BMR الخاص بك بانتظام. تمامًا مثل أي حمية تقييدية قليلة السعرات،
                سيستجيب جسمك بشكل غريزي عن طريق تخزين المزيد من الطاقة بدلاً من
                استخدامها لأنه يتوقع تدفقًا محدودًا من الطاقة الجديدة. بدلاً من
                ذلك، يمكنك النظر في هذه النصائح المعتمدة من قبل الخبراء لفقدان
                الوزن بطريقة آمنة ومستدامة.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  ماذا يُستخدم معدل الأيض الأساسي له؟
                </h3>
              </div>
              <div className="info-section-body">
                يُستخدم معدل الأيض الأساسي لمساعدة الشخص ومقدمي الرعاية الصحية
                الخاصين به على فهم كمية الطاقة (أو كمية السعرات الحرارية) التي
                يحتاجها جسمه للحفاظ على وظائفه الحيوية يوميًا. بهذه المعلومات في
                الاعتبار، يمكن للأفراد فهم أفضل لاحتياجات الطاقة الأساسية
                لجسدهم، ويمكن للخبراء أن يبدؤوا في تصميم مجموعة متنوعة من
                التدخلات الصحية، مثل خطط النظام الغذائي أو التمارين المصممة
                خصيصًا لأهداف العافية الخاصة بتلك الشخص في طريقة آمنة وفعّالة
                ومستدامة.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  هل من الأفضل أن يكون لدي معدل أيضي أساسي عالي أم منخفض؟
                </h3>
              </div>
              <div className="info-section-body">
                ليس من الأفضل ولا من الأسوأ أن يكون لديك BMR عالي أو منخفض -
                القياس متناسب ببساطة مع كتلة الجسم الخالية من الدهون للشخص، وليس
                دائمًا دليلًا على الصحة المثلى. على سبيل المثال، من المرجح أن
                يكون لدى شخص يعاني من السمنة BMR أعلى من شخص غير سمين لأنه يحتاج
                إلى مزيد من الطاقة لأداء الأنشطة المحمولة الوزن مثل المشي
                والوقوف. وفي الوقت نفسه، من المرجح أن يكون لدى شخص نحيل بكتلة
                عضلية كبيرة BMR أعلى من شخص نحيل بدون الكثير من كتلة العضلات
                لأسباب مماثلة. المعدل الأمثل لـ BMR يعتمد على الفرد وحالته
                الصحية وأهدافه الصحية الخاصة.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  هل يجب أن ينخفض BMR الخاص بي مع فقدان الوزن؟
                </h3>
              </div>
              <div className="info-section-body">
                باختصار، يعتمد الأمر على الاستراتيجيات المستخدمة لفقدان الوزن.
                العديد من الأشخاص الذين يفقدون وزنهم بسبب تقييد السعرات الحرارية
                وحدها يقللون في النهاية من إنفاق طاقة جسمهم (و BMR) بسبب كيفية
                تكيف التمثيل الغذائي مع هذا التقييد. ومع ذلك، قد يفقد الشخص الذي
                يفقد كتلة الدهون في الجسم مع زيادة كتلة العضلات وزنه بمعدل أبطأ
                ولكنه على الأرجح يزيد من BMR بمعدل تغيير تكوين جسده.
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default BMRCalculator;
